import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=2b51176f"
import script from "./MenuButton.vue?vue&type=script&lang=js"
export * from "./MenuButton.vue?vue&type=script&lang=js"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=2b51176f&lang=scss&module=true"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./MenuButton.vue?vue&type=style&index=0&id=2b51176f&lang=scss&module=true"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./MenuButton.vue?vue&type=style&index=0&id=2b51176f&lang=scss&module=true")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js").rerender("2b51176f")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b51176f')) {
      api.createRecord('2b51176f', component.options)
    } else {
      api.reload('2b51176f', component.options)
    }
    module.hot.accept("./MenuButton.vue?vue&type=template&id=2b51176f", function () {
      api.rerender('2b51176f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/MenuButton.vue"
export default component.exports